import { IconLoginLogo } from "@/assets/icons/IconLoginLogo";
import { LoginVerifyForm } from "@/features/auth/components/LoginVerifyForm";
import { AppRoutes } from "@/routes/config";
import { black } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

type TLoginVerifyLocationState = {
  email: string;
  pendingAuthToken: string;
};

export const LoginVerifyPage: FC = () => {
  const location = useLocation();
  const state = location.state as TLoginVerifyLocationState | null;

  if (!state?.email || !state?.pendingAuthToken) {
    return <Navigate to={AppRoutes.pageNotFound} replace />;
  }

  return (
    <Stack gap="80px" alignItems="center" width="100%">
      <Stack gap={1}>
        <IconLoginLogo />
        <Stack alignItems="center" width={240} paddingY={1} bgcolor={black[30]}>
          <Typography variant="sub16Bold" color="white">
            center│システム管理
          </Typography>
        </Stack>
      </Stack>
      <LoginVerifyForm />
    </Stack>
  );
};
